exports = module.exports = require("../../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"-webkit-box-orient": "horizontal",
	"-webkit-box-direction": "reverse",
	"-webkit-flex-direction": "row,column,row-reverse,column-reverse",
	"-ms-flex-direction": "row,column,row-reverse,column-reverse",
	"flex-direction": "row,column,row-reverse,column-reverse",
	"-webkit-flex-wrap": "wrap,nowrap,wrap-reverse",
	"-ms-flex-wrap": "wrap,nowrap,wrap-reverse",
	"flex-wrap": "wrap,nowrap,wrap-reverse",
	"-webkit-box-flex": "0,1",
	"-webkit-flex-grow": "0,1",
	"-ms-flex-positive": "0,1",
	"flex-grow": "0,1",
	"-webkit-flex-shrink": "0,1",
	"-ms-flex-negative": "0,1",
	"flex-shrink": "0,1",
	"-webkit-box-pack": "start,end,center,between,around,evenly",
	"-webkit-justify-content": "start,end,center,between,around,evenly",
	"-ms-flex-pack": "start,end,center,between,around,evenly",
	"justify-content": "start,end,center,between,around,evenly",
	"-webkit-box-align": "start,end,center,baseline,stretch",
	"-webkit-align-items": "start,end,center,baseline,stretch",
	"-ms-flex-align": "start,end,center,baseline,stretch",
	"align-items": "start,end,center,baseline,stretch",
	"-webkit-align-content": "start,end,center,between,around,stretch",
	"-ms-flex-line-pack": "start,end,center,between,around,stretch",
	"align-content": "start,end,center,between,around,stretch",
	"-webkit-align-self": "auto,start,end,center,baseline,stretch",
	"-ms-flex-item-align": "auto,start,end,center,baseline,stretch",
	"align-self": "auto,start,end,center,baseline,stretch"
};